import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { AppCommonService } from '../appcommon.service';
import { IBlog } from '../blogs/blog';
import { BlogService } from '../blogs/blog.service';
import { BlogType } from './blogtypes';
declare var $: any;
@Component({
  templateUrl: "./mybusinessadvantage.component.html"
})
export class MyBusinessAdvantageComponent implements OnInit, AfterViewInit {
  public pageTitle: string = 'My Business Advantage';
  blogsList: IBlog[];
  category: string;
  constructor(private authService: AuthService,
    private appCommonService: AppCommonService,
    public blogService: BlogService,
  ) {
    this.appCommonService.pageContentAdditionalClass = "home-page main-page";
    this.appCommonService.pageName = this.pageTitle;
  }
  ngOnInit() {
    this.category = BlogType.mybusinessadvantage;
    this.loadBlogsList();
    window.scrollTo(0, 0);
  }

  ngAfterViewInit() {
    this.appCommonService.loadRequiredJS();    
    $('.tabs-left li a').hover(function () {      
      $(this).trigger('click');
    });
    $('.sliderformobile').bxSlider({
      auto: true,
      pager: true,
      controls: false,
      touchEnabled: true,
      adaptiveHeight: true
    });
  }

  loadBlogsList() {
    this.blogService.getBlogsList(this.category)
      .subscribe(
      (blogs: IBlog[]) => {
        this.blogsList = blogs;
      },
      (error: any) => {
        this.blogService.showError("Blog retrieval problem", <any>error)
      }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/genericpages/mybusinessadvantage.component.ts